<template>
  <div :class="bem.e('table')">
    <div v-if="props.type === 'xml'" :class="bem.m('xml')">
      {{'<?xml version="1.0" encoding="UTF-8"?>'}}
    </div>
    <a-row :class="bem.m('table-header')" :gutter="20">
      <a-col :span="7" style="padding-left: 60px"> 名称 </a-col>
      <a-col :span="3"> 类型 </a-col>
      <a-col :span="4"> Mock </a-col>
      <a-col :span="4"> 中文名 </a-col>
      <a-col :span="4"> 说明 </a-col>
      <a-col :span="2"> 操作 </a-col>
    </a-row>
    <div :class="bem.m('table-body')">
      <table-row
        v-for="(item, index) in props.dataSource"
        :key="index"
        :list="props.dataSource"
        :data="item"
        :tree-key="(index + 1).toString()"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import TableRow from './json-xml-table-row.vue'

import { createNamespace } from '@ll-plus/utils'

import { jsonXmlTableProps, jsonXmlTableEmits } from '../config'

defineOptions({ name: 'LlJsonXmlTable' })

const bem = createNamespace('json-xml')

const props = defineProps(jsonXmlTableProps)

const emits = defineEmits(jsonXmlTableEmits)
const handleChange = child => {
  emits('change', [child])
}
</script>
